import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { OrderByPage } from './order-by.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'order-by',
        component: OrderByPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [OrderByPage],
    exports: [OrderByPage]
})
export class OrderByPageModule {}
